import { render, staticRenderFns } from "./MobStockTable.vue?vue&type=template&id=542b4246&scoped=true"
import script from "./MobStockTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MobStockTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobStockTable.vue?vue&type=style&index=0&id=542b4246&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b4246",
  null
  
)

export default component.exports